import { Component, Input, OnInit } from '@angular/core';
import { CartItem, SupplyItem } from '@app/model/cart.model';

@Component({
    selector: 'app-cart-item-price',
    templateUrl: './cart-item-price.component.html',
    styleUrls: ['./cart-item-price.component.scss']
})
export class CartItemPriceComponent implements OnInit {

    @Input() cartItem: CartItem;
    isSamplingSupply: boolean;
    isFree: boolean;

    constructor() { }

    ngOnInit() {
        this.isSamplingSupply = this.cartItem instanceof SupplyItem;
        this.isFree = this.cartItem.quantityPrice.amount === 0;
    }
}
